import { SubanchorProvider } from "@/components/signup/hooks/use-subanchor";
import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";
import { ConfirmationPageTemplate } from "@/templates/ondemand/signup/confirmation/confirmation-page/src";

import { getFeatureFlagValues } from "../../../../wac-routes";

export type ConfirmationPageProps = {
    availableProducts: AvailableProductsResponse | null;
};

export const ConfirmationPage = ({
    availableProducts
}: ConfirmationPageProps) => {
    return (
        <SubanchorProvider>
            <ConfirmationPageTemplate
                featureFlags={
                    window.featureFlags ||
                    getFeatureFlagValues(window.location.search.split("&"))
                }
                isProduction={
                    process.env["CLIENT_LIBRARY_ENV"] === "production"
                }
                // @ts-ignore
                availableProducts={availableProducts}
            />
        </SubanchorProvider>
    );
};
